import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from "classnames";
import { useSelector } from "react-redux";
import './Form.css'
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const {keys} = useKeysStore();
    const session = useSelector((state) => { return state.core.session });
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const { id } = useParams();
    let [activeTab,setActiveTab] = useState('1');

    const profileFilter = chooseProfileFilter()
    const hiddenValues = {profileFilter}

    const path = '/fileaccountabilities/';
    let verifyProfile = Object.keys(profileFilter).length === 0;
    if(!verifyProfile){
        verifyProfile = profileFilter.pdc_entity_id ? true : false;
    }

    const paths = {
        endpointSave: config.endpoints.backend + 'fileaccountabilities/save',
        endpointGetById: config.endpoints.backend + 'fileaccountabilities/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllIntegrationSystems: config.endpoints.backend + 'integrationsystems/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Importar PContas",
        labelTitleEdit: "Editar Importação PConta",
        labelTitleView: 'Visualizar Importação PConta'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'pdc_integration_system_id',
                    type: 'select',
                    label: 'Sistema - Integração',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllIntegrationSystems,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    readOnly: true,
                    columnSize: 12,
                    canAutoFill: true
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    label: 'Arquivo FDB de prestação de contas.',
                    extensionAccept: '.zip',
                    limitFileSize: 1000,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {pdc_integration_system_id: keys?.default_foreign_key?.pdc_integration_systems?.pc_contas};
            
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        style={{cursor:'pointer'}}
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => { setActiveTab('1'); }}
                    >
                        Formulário
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        style={{cursor:'pointer'}}
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => { setActiveTab('2'); }}
                    >
                    Erros
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <Row>
                        <Col sm="12">
                        {formContent}
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row>
                        <Col sm="12">
                            <p className="upload-error">{session.current_form?session.current_form.error_message:''}</p>
                        </Col>
                    </Row>
                </TabPane>  
            </TabContent>
        </div>
    );
}
export default Form;
